import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { exportar } from '../../utils/Exportar';
import { getAuthenticated } from '../../utils/LocalStorage';

import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const cssIconButton = {
  display: { md: 'flex', lg: 'none' },
  minWidth: '45px',
  width: '45px',
  height: '45px',
  borderRadius: '4px',
  padding: 0,
};

export default function DocumentosToolbar(props) {
  const navigate = useNavigate();

  const [usuarioAdministrador, setUsuarioAdministrador] = useState(false);

  const usuarioEhAdministrador = (callback) => {
    getAuthenticated((usuario)=>{
      callback(usuario.usuario_administrador);
    });
  };

  useEffect(()=>{
    usuarioEhAdministrador((administrador)=>{
      setUsuarioAdministrador(administrador);
    });
  },[]);

  const isSelected = (props.selected !== '');
  return (
    <Toolbar
      position="static"
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifycontent: 'flex-start',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography
          variant="h6"
          id="tableTitle"
          component="div"
          sx={{
            marginRight: '10px',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          Documentos
        </Typography>

        <TextField
            fullWidth
            id={`search-input`}
            sx={{ m: 1, minWidth: '300px' }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            onChange={props.handleSearch}
          />
      </Box>

      <Box
        sx={{
          flex: 2,
          justifyContent: 'flex-end',
          alignItems: 'right',
          gap: 2,
          ml: 'auto',
          display: { xs: 'none', sm: 'flex' },
        }}
      >
        <Stack direction="row" spacing={1} justifycontent="flex-end">
          {isSelected ? (
            <>
              {
                (usuarioAdministrador) ? (
                  <Tooltip title="Excluir">
                    <Button
                      sx={{ display: { md: 'none', lg: 'flex' } }}
                      variant="contained"
                      startIcon={<DeleteIcon />}
                      size="large"
                      color="error"
                      onClick={()=>{props.setOpenConfirmDialog(true)}}>
                      Excluir
                    </Button>
                    <Button
                      sx={cssIconButton}
                      variant="contained"
                      size="large"
                      color="error"
                      onClick={()=>{props.setOpenConfirmDialog(true)}}>
                      <DeleteIcon />
                    </Button>
                  </Tooltip>
                ) : (<></>)
              }

              <Tooltip title="Editar">
                <Button
                  sx={{ display: { md: 'none', lg: 'flex' } }}
                  variant="contained"
                  size="large"
                  startIcon={<EditIcon />}
                  onClick={()=>{
                    navigate(`/documento/${props.selected}`);
                  }}>
                  Editar
                </Button>
                <Button
                  sx={cssIconButton}
                  variant="contained"
                  size="large"
                  onClick={()=>{
                    navigate(`/documento/${props.selected}`);
                  }}>
                  <EditIcon />
                </Button>
              </Tooltip>

              <Tooltip title="Exportar">
                <Button
                  sx={{ display: { md: 'none', lg: 'flex' } }}
                  variant="contained"
                  size="large"
                  startIcon={<TextSnippetIcon />}
                  onClick={()=>{exportar(props.selected)}}>
                  Exportar
                </Button>
                <Button
                  sx={cssIconButton}
                  variant="contained"
                  size="large"
                  onClick={()=>{exportar(props.selected)}}>
                  <TextSnippetIcon />
                </Button>
              </Tooltip>

              {
                ((props.situacaoNome !== 'Revisado') && usuarioAdministrador) ? (
                  <Tooltip title="Revisar">
                    <Button
                      sx={{ display: { md: 'none', lg: 'flex' } }}
                      variant="contained"
                      size="large"
                      color="success"
                      startIcon={<CheckBoxIcon />}
                      onClick={()=>{
                        props.handleRevisarDocumento(()=>{});
                      }}>
                      Revisar
                    </Button>
                    <Button
                      sx={cssIconButton}
                      variant="contained"
                      size="large"
                      color="success"
                      onClick={()=>{
                        props.handleRevisarDocumento(()=>{});
                      }}>
                      <CheckBoxIcon />
                    </Button>
                  </Tooltip>
                ) : (<></>)
              }
            </>
          ) : (<></>)}

          <Button
            variant="contained"
            size="large"
            color="success"
            startIcon={<NoteAddIcon />}
            onClick={()=>{props.setOpenDocumentoDialog(true)}}>
            Novo
          </Button>
        </Stack>
      </Box>

    </Toolbar>
  );
}
